/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantMasterData } from '../../models/tenant-master-data';
import { TenantMasterDataCreateRequest } from '../../models/tenant-master-data-create-request';

export interface CreateTenantMasterData$Params {

/**
 * tenant shortcode
 */
  tenant_short_code: string;
      body: TenantMasterDataCreateRequest
}

export function createTenantMasterData(http: HttpClient, rootUrl: string, params: CreateTenantMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantMasterData>> {
  const rb = new RequestBuilder(rootUrl, createTenantMasterData.PATH, 'post');
  if (params) {
    rb.path('tenant_short_code', params.tenant_short_code, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantMasterData>;
    })
  );
}

createTenantMasterData.PATH = '/api/v1/tenants/{tenant_short_code}/masterdata';
